import { combineEpics } from 'redux-observable';
import { getDataEpic } from '.';

export default combineEpics(
  getDataEpic,
);
